import AutoSizer from 'react-virtualized-auto-sizer'

import { CriteriaType, ValueAddType } from '@constants'
import { AutocompleteOption } from '@types'

import { SearchAssistantSelectOption } from '../SearchAssistantSelectOption/SearchAssistantSelectOption'

const AUTOSIZER_WITH_OFFSET = 2

interface CriteriaFieldsProps {
  criterias: CriteriaType[]
  autocompleteOptions?: CriteriaType[]
  disabled: boolean
  onUpdateAutocomplete: (newCriteria: CriteriaType, newValue: AutocompleteOption) => void
  // Вызывается при onBlur и onChange на все остальные поля кроме Autocomplete
  onUpdateCriteriaValue: (value: ValueAddType) => void
}

export const CriteriaFields: React.FC<CriteriaFieldsProps> = props => {
  const {
    criterias,
    autocompleteOptions,
    disabled,
    onUpdateAutocomplete,
    onUpdateCriteriaValue: handleUpdateCriteriaValue,
  } = props

  const visibleCriteriaNames = criterias.map(visiblePinnedCriteria => visiblePinnedCriteria.title)

  const handleChangeAutocomplete = (newCriteria: CriteriaType) => (value: AutocompleteOption) => {
    onUpdateAutocomplete(newCriteria, value)
  }

  return (
    <AutoSizer disableHeight style={{ width: '100%' }}>
      {size => {
        const width = size.width >= AUTOSIZER_WITH_OFFSET ? size.width - AUTOSIZER_WITH_OFFSET : 0

        return criterias.map(criteria => (
          <SearchAssistantSelectOption
            key={criteria.codeCriteria}
            assistantCriteria={criteria}
            currentCriteriaNames={visibleCriteriaNames}
            disabled={disabled}
            options={autocompleteOptions}
            width={width}
            onChange={handleChangeAutocomplete(criteria)}
            onChangeCriteriaValue={handleUpdateCriteriaValue}
            // TODO(isilanov): Отследить будут ли баги из-за отсутствия onChangeInputValue
            // eslint-disable-next-line react/jsx-handler-names, @typescript-eslint/no-empty-function
            onChangeInputValue={() => {}}
            // onChangeInputValue={handleChangeInputValue(criteria, true)}
          />
        ))
      }}
    </AutoSizer>
  )
}

CriteriaFields.displayName = 'CriteriaFields'
